var _path, _g, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 278,
    viewBox: "0 0 278 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 277.106C215.521 277.106 277.553 215.074 277.553 138.553C277.553 62.0322 215.521 0 139 0C104.669 0 91.6193 41.1775 67.4145 61.8565C37.6691 87.2691 0.447266 96.3633 0.447266 138.553C0.447266 215.074 62.4795 277.106 139 277.106Z",
    fill: "#DDF0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_456_5856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.132 90.0596H102.053C98.2266 90.0596 95.125 92.7117 95.125 95.9832V220.38C95.125 223.651 98.2266 226.303 102.053 226.303H222.132C225.958 226.303 229.059 223.651 229.059 220.38V95.9832C229.059 92.7117 225.958 90.0596 222.132 90.0596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.132 90.0596H102.053C98.2266 90.0596 95.125 92.7117 95.125 95.9832V220.38C95.125 223.651 98.2266 226.303 102.053 226.303H222.132C225.958 226.303 229.059 223.651 229.059 220.38V95.9832C229.059 92.7117 225.958 90.0596 222.132 90.0596Z",
    fill: "#CDE9FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2695 92.3685C81.2695 82.1657 89.5405 73.8948 99.7433 73.8948H187.493C197.696 73.8948 205.967 82.1657 205.967 92.3685V191.665C205.967 201.867 197.696 210.138 187.493 210.138H99.7432C89.5405 210.138 81.2695 201.867 81.2695 191.665V92.3685Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.019 101.185C219.803 103.81 219.931 108.194 217.305 110.978L157.895 173.96C155.269 176.743 150.885 176.871 148.102 174.246C145.319 171.621 145.191 167.236 147.816 164.453L207.226 101.47C209.852 98.6873 214.236 98.5593 217.019 101.185Z",
    fill: "#DDF0FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_456_5856",
    x: 80.183,
    y: 75.1176,
    width: 163.819,
    height: 166.128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.47099,
    result: "effect1_foregroundBlur_456_5856"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.18df60e5ff21747fce17f8944830af8a.svg";
export { ForwardRef as ReactComponent };